<label class="control-label">
  <span class="form-label" *ngIf="title && title.length > 0">
    {{ title }}
    <span *ngIf="secondaryTitle"> - </span>
    <small>{{ secondaryTitle }}</small>
  </span>
</label>

<div class="row pl-3">
  <div
    class="radio"
    *ngFor="let option of options; let i = index"
    [ngClass]="{ requiredRadio: requiredRadio && !isTouched }"
    [attr.data-qa]="option.testId"
  >
    <ng-container *ngIf="!option.showBelowMainBlock">
      <div *ngIf="option.imageSrc">
        <img class="my-2 mr-3" [src]="option.imageSrc" />
      </div>

      <input
        type="radio"
        class="sr-only"
        [attr.name]="name"
        id="option{{ option.id }}"
        (change)="onToggle(option)"
        [attr.disabled]="disabled || null"
        [ngClass]="{ disabled: disabled }"
        [value]="option.id"
        [checked]="option.isSelected"
      />
      <label *ngIf="!option.tooltipText" for="option{{ option.id }}" [innerHTML]="option.name"> </label>
      <label *ngIf="option.tooltipText" for="option{{ option.id }}">
        {{ option.name }}
        <rx-tooltip class="align-middle" [position]="tooltipPosition" [text]="option.tooltipText" [isMobile]="isMobile">
        </rx-tooltip>
      </label>
    </ng-container>
  </div>
</div>

<div
  class="radio"
  *ngFor="let option of options; let i = index"
  [ngClass]="{ requiredRadio: requiredRadio && !isTouched }"
  [attr.data-qa]="option.testId"
>
  <ng-container *ngIf="option.showBelowMainBlock">
    <input
      type="radio"
      class="sr-only"
      [attr.name]="name"
      id="option{{ option.id }}"
      (change)="onToggle(option)"
      [attr.disabled]="disabled || null"
      [ngClass]="{ disabled: disabled }"
      [value]="option.id"
      [checked]="option.isSelected"
    />
    <label *ngIf="!option.tooltipText" for="option{{ option.id }}" [innerHTML]="option.name"> </label>
    <label *ngIf="option.tooltipText" for="option{{ option.id }}">
      {{ option.name }}
      <rx-tooltip class="align-middle" [position]="tooltipPosition" [text]="option.tooltipText" [isMobile]="isMobile">
      </rx-tooltip>
    </label>
  </ng-container>
</div>

<ng-content select="[rx-error]"></ng-content>

<div rx-error *ngIf="error" class="rx-error">{{ error }}</div>
